import React from 'react'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import Box from '@material-ui/core/Box'
import Button from '@material-ui/core/Button'

import EDI from './EDI'
import Error from './Error'
import { triggerEDI } from 'http/tank'
import { setLoader } from 'utils/loader'
import { ITank } from 'types'

interface IProps {
  tank: ITank
}

interface IState {
  error: any
  newEDI: any
}

class Order extends React.PureComponent<IProps, IState> {
  constructor(props: IProps) {
    super(props)
    this.state = {
      error: null,
      newEDI: null,
    }
  }

  placeOrder = async () => {
    setLoader(true)
    try {
      const data = await triggerEDI(this.props.tank.deviceID)
      if (data.messageStatus == 'success') {
        this.setState({
          newEDI: data.data,
          error: null,
        })
      } else {
        this.setState({
          error: {
            code: data.messageCode,
            message: data.errorMessage,
            newEDI: null,
          },
        })
      }
    } catch (error) {
      console.log(error)
    }
    setLoader(false)
  }

  render() {
    const { tank } = this.props
    const { error, newEDI } = this.state

    const edi = newEDI || tank.edi
    let placeOrderDisabled = false
    const value = tank.info.value * 100

    if (edi || value > 80) {
      placeOrderDisabled = true
    }

    return (
      <Grid
        container
        direction="column"
        justify="space-between"
        style={{ height: '100%' }}
      >
        <Grid container direction="column">
          {tank.edisetup && (
            <Grid item>
              <Typography variant="h4" color="error">
                EDI has been set up
              </Typography>
            </Grid>
          )}
          {!error && (
            <Grid item>
              <EDI edi={edi} level={value} />
            </Grid>
          )}
          {error && (
            <Grid item>
              <Error error={error} />
            </Grid>
          )}
        </Grid>
        <Grid item>
          <Box my={{ xs: 1 }}>
            <Button  style={{ display: localStorage.getItem('user_role') == "1" ? "none": "", }}
         fullWidth variant="contained" type="submit" disabled={placeOrderDisabled} onClick={this.placeOrder}>
              <Typography variant="h4" color="primary">
                Place Order
              </Typography>
            </Button>
          </Box>
        </Grid>
      </Grid>
    )
  }
}

export default React.memo(Order)
